let activePopup = null;
let previousFocus = null;
let isOpening = false; // flag per evitare race conditions

function openPopup(popup) {
	if (activePopup) closePopup(activePopup, false);
	isOpening = true;
	activePopup = popup;
	previousFocus = document.activeElement;
	popup.removeAttribute("hidden");
	popup.offsetHeight;
	popup.classList.add("is-open");
	document.body.classList.add("bananau-popup-open");
	document.body.style.overflow = "hidden"; // ← aggiunto
	popup.querySelector(".bananau-popup__inner")?.focus({ preventScroll: true });
	requestAnimationFrame(() => {
		isOpening = false;
	});
}

function closePopup(popup, restoreFocus = true) {
	if (!popup) return;
	requestAnimationFrame(() => {
		popup.classList.remove("is-open");
	});
	setTimeout(() => {
		popup.setAttribute("hidden", "");
		if (activePopup === popup) activePopup = null;
		if (!activePopup) {
			document.body.classList.remove("bananau-popup-open");
			document.body.style.overflow = ""; // ← aggiunto
		}
	}, 280);
	previousFocus = null;
}

let initialized = false;

export function initModal() {
	if (initialized) return;
	initialized = true;
	// ESC
	document.addEventListener("keydown", (e) => {
		if (activePopup && e.key === "Escape") closePopup(activePopup);
	});

	// Click delegation
	document.addEventListener("click", (e) => {
		// Bottone close
		if (e.target.closest(".bananau-popup__close")) {
			e.stopPropagation();
			closePopup(activePopup);
			return;
		}

		// Overlay
		if (e.target.closest(".bananau-popup__overlay")) {
			closePopup(activePopup);
			return;
		}

		// Trigger — ignora se stiamo già aprendo (evita double-open)
		if (isOpening) return;

		const trigger = e.target.closest("[data-popup-id]");
		if (trigger) {
			const popup = document.getElementById(trigger.dataset.popupId);
			if (popup) activePopup === popup ? closePopup(popup) : openPopup(popup);
		}
	});

	window.BananauPopup = {
		open: (id) => {
			const p = document.getElementById(id);
			if (p) openPopup(p);
		},
		close: (id) => {
			const p = id ? document.getElementById(id) : activePopup;
			if (p) closePopup(p);
		},
	};
}

export { openPopup, closePopup };
